// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'General Sans', 'General Sans Fallback'"},"className":"__className_34246c"};